// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3162":"65817b9f","3795":"88f3b24f","4338":"16e1b171","5666":"bd1b95b2","7508":"8a372c7d","9437":"9ff5db10"}[chunkId] + ".chunk.css";
};